// GAVION product-training: Formation → « Produit ». Two tracks of quiz missions; the price questions come from the
// live catalog (packages / package_addons, read by every active user), the others from the approved content.
import { useTranslate } from "ra-core";
import type {
  PlayableKey,
  ProductMissionKey,
} from "../domain/training/missions";
import type { MissionView } from "../domain/training/progress";
import type { QuizQuestion } from "./content/types";
import { STATIC_QUESTIONS } from "./content/product/staticQuestions";
import { MissionMap } from "./MissionMap";

export const ProductCourse = ({
  views,
  questions,
  onPlay,
}: {
  views: readonly MissionView[];
  questions: Record<ProductMissionKey, readonly QuizQuestion[]> | null;
  onPlay: (key: PlayableKey) => void;
}) => {
  const t = useTranslate();
  const sizes = Object.fromEntries(
    Object.entries(questions ?? STATIC_QUESTIONS).map(([k, q]) => [
      k,
      q.length,
    ]),
  ) as Partial<Record<PlayableKey, number>>;
  const unavailable = new Set<PlayableKey>(
    (["product_pricing", "product_addons"] as const).filter(
      (k) => !questions || questions[k].length === 0,
    ),
  );
  const track = (name: "sell" | "deep") =>
    views.filter((v) => v.mission.type === "game" && v.mission.track === name);
  return (
    <div className="space-y-6">
      <MissionMap
        views={track("sell")}
        onPlay={onPlay}
        title={t("gavion.training.product.tracks.sell.title")}
        subtitle={t("gavion.training.product.tracks.sell.subtitle")}
        headingId="gavion-training-product-sell"
        sizes={sizes}
        unavailable={unavailable}
      />
      <MissionMap
        views={track("deep")}
        onPlay={onPlay}
        title={t("gavion.training.product.tracks.deep.title")}
        subtitle={t("gavion.training.product.tracks.deep.subtitle")}
        headingId="gavion-training-product-deep"
        lockedHint={t("gavion.training.product.tracks.deep.locked_hint")}
        sizes={sizes}
        unavailable={unavailable}
      />
    </div>
  );
};
